module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[34]155.f47c570.woff2";